export class specSheetRequest{
    specSheetId : number;
    
    constructor(specSheetId : number)
    {
        this.specSheetId = specSheetId;
        
    }
}
